<script setup lang="ts">
import Marketing from "~/components/Home/Marketing/Index.vue";
import HomeOld from "~/components/Home/HomeOld/Index.vue";
import { useAuthStore } from "~/stores/auth/store";

useSeoMeta({
  title: "Home | PokerGO",
  ogTitle: "Home | PokerGO",
  twitterTitle: "Home | PokerGO",
});

const authStore = useAuthStore();
</script>

<template>
  <HomeOld v-if="authStore.authenticated" />
  <Marketing v-else />
</template>

<style scoped></style>
